import React from "react";
import {
    Box,
    Button,
    Checkbox,
    Column,
    Columns,
    Field,
    Input,
    Select,
    TextArea,
    Title,
} from "@allxsmith/bestax-bulma";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import ContactSection from "../Contact/ContactSection";
import MovementTypePicker from "../Settings/MovementType/MovementTypePicker";
import MovementRatePicker from "./MovementRatePicker";
import useButtonSelect from "../../hooks/useButtonSelect";
import CashSaleSection from "../Contact/CashSaleSection";


export default function CustomerChargerSection({data, onChange, onCheck, departments, onDepartmentChange, movementRates, onMovementRateChange,
                                                   movementTypes, onMovementTypeChange, endpoint, onCustomerChange, addCashSale, onCashSaleChange}){

    const options = [
        {name: "Normal", value: "NORMAL"},
        {name: "Quote", value: "QUOTE"}
    ];

    const customerPaymentOptions = [
        {name:"", value: "BLANK"},
        {name: "BACS", value: "BACS"},
        {name: "CASH", value: "CASH"},
        {name: "CARD", value: "CARD"},
        {name: "DIRECT DEBIT", value: "DIRECT DEBIT"}
    ];

    const [statusOption, statusOptionInput] = useButtonSelect({
        label: "Status",
        initialValue: "NORMAL",
        prop: "movement_status",
        options: options,
        callback: onChange
    });

    const handleCustomerChange = e => {
        onCustomerChange(e, "customer");
    }

    return (
        <Box>
            <Columns isMultiline>
                <Column>
                    <Columns isMultiline>
                        <Column>
                            <ContactSection
                                title={"Customer"}
                                contactUpdate={handleCustomerChange}
                                endpoint={endpoint+"contacts"}
                                contact={data.customer || {}}
                                type={"CC"}
                            />
                        </Column>
                    </Columns>
                    {data.customer.is_cash_sale &&
                        <Box>
                            <Columns isMultiline>
                                <Column>
                                    <Title>Cash Sale</Title>
                                </Column>
                                {data.cash_sale.length == 0 &&
                                <Column>
                                    <Button
                                        color={"success"}
                                        onClick={() => addCashSale()}
                                    >
                                        Add Cash Sale +
                                    </Button>
                                </Column>
                                }
                            </Columns>
                        </Box>
                    }
                    {data.customer.is_cash_sale &&
                        data.cash_sale.map((sale, index) => (
                            <Columns isMultiline>
                                <Column>
                                    <CashSaleSection
                                        data={sale}
                                        index={index}
                                        addCashSale={addCashSale}
                                        onChange={onCashSaleChange}
                                    />
                                </Column>
                            </Columns>
                        ))
                    }
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Title>Customer Charger Section</Title>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <DepartmentSelector
                        name={"department"}
                        label={"Customer Charger"}
                        value={data.department}
                        options={departments}
                        onChange={onDepartmentChange}
                        editable={true}
                    />
                </Column>
                <Column>
                    {statusOptionInput}
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Vehicle/Goods To Move</label>
                    <Input
                        type={"text"}
                        value={data.vehicle}
                        name={"vehicle"}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Delivery Date</label>
                    <Input
                        type={"date"}
                        value={data.delivery_date}
                        name={"delivery_date"}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <MovementTypePicker
                        options={movementTypes}
                        value={data.movement_type}
                        editable={true}
                        label={"Movement Type"}
                        onChange={onMovementTypeChange}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Start Address</label>
                    <TextArea
                        name={"start_address"}
                        value={data.start_address}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">End Address</label>
                    <TextArea
                        name={"end_address"}
                        value={data.end_address}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Start time (*)</label>
                    <Input
                        type={"time"}
                        name={"start_time"}
                        value={data.start_time}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">End time (*)</label>
                    <Input
                        type={"time"}
                        name={"end_time"}
                        value={data.end_time}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Order Number</label>
                    <Input
                        value={data.order_number}
                        name={"order_number"}
                        onChange={onChange}
                        type={"text"}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <MovementRatePicker
                        options={movementRates}
                        label={"Movement Rate"}
                        editable={true}
                        movement={data}
                        onChange={onMovementRateChange}
                    />
                </Column>
                <Column>
                    <label className="label">Rate Comments</label>
                    <TextArea
                        disabled={true}
                        value={data.movement_rate ? data.movement_rate.comments : ""}
                    />
                </Column>
                <Column>
                    <label className="label">Cost Per Mile</label>
                    <Input
                        name={"cost_per_mile"}
                        disabled={true}
                        value={data.movement_rate ? data.movement_rate.cost_per_mile : 0}
                        onChange={onChange}
                        type={"number"}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Distance (Miles)</label>
                    <Input
                        name={"miles"}
                        value={data.miles}
                        onChange={onChange}
                        type={"number"}
                    />
                </Column>
                <Column>
                    <label className="label">Customer Charge</label>
                    <Input
                        name={"cost"}
                        value={data.cost}
                        onChange={onChange}
                        type={"number"}
                        disabled={!data.cost_override}
                    />
                </Column>
                <Column>
                    <Field>
                        <label className="label">Cost Override</label>
                        <Checkbox
                            name={"cost_override"}
                            checked={data.cost_override}
                            onChange={onCheck}
                        />
                    </Field>
                </Column>
                <Column>
                    <label className="label">Additional Customer Charge</label>
                    <Input
                        name={"customer_additional_charge"}
                        value={data.customer_additional_charge}
                        onChange={onChange}
                        type={"number"}
                    />
                </Column>
                <Column>
                    <label className="label">Total Customer Charge</label>
                    <Input
                        disabled={true}
                        value={parseFloat(data.cost) + parseFloat(data.customer_additional_charge)}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Customer Amount Paid</label>
                    <Input
                        type={"number"}
                        value={data.customer_paid_amount}
                        onChange={onChange}
                        name={"customer_paid_amount"}
                    />
                </Column>
                <Column>
                    <label className="label">Customer Payment Method</label>
                    <Select
                      name={"customer_payment_method"}
                      value={data.customer_payment_method}
                      onChange={onChange}
                    >
                      {customerPaymentOptions.map(method => (
                          <option value={method.value}>{method.name}</option>
                      ))}
                    </Select>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Internal Comments</label>
                    <TextArea
                        name={"comments"}
                        value={data.comments}
                        onChange={onChange}
                    />
                </Column>
            </Columns>
        </Box>
    );



}